import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { getUserPoints, UserPoints } from '../api/usersApi';
import Table from '../components/Table';
import { getUserPointsColumns } from '../utils/userPointsTableUtils';

const Leaderboard: React.FC = () => {
  const { user } = useAuth();
  const [userPoints, setUserPoints] = useState<UserPoints[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getUserPoints()
      .then(points => { setUserPoints(points); setError(null); })
      .catch(() => setError('Failed to load user points'))
      .finally(() => setLoading(false));
  }, []);

  const columns = getUserPointsColumns();

  return (
    <Layout>
      <div className="container mx-auto">
        {error ? (
          <div className="text-stake-red text-center p-4">{error}</div>
        ) : (
          <Table
            title="טבלת ניקוד"
            data={userPoints}
            withRanks={true}
            columns={columns}
            rowLimit={10}
            keyExtractor={(item) => `${item.first_name}-${item.last_name}`}
            emptyMessage="No user points data available"
            isLoading={loading}
            highlightCondition={(item) => item.id === user?.id}
            legend={[
              { color: 'bg-green-600', label: 'מושלם' },
              { color: 'bg-blue-500', label: 'חלקי' },
              { color: 'bg-gray-500', label: 'כלום' },
            ]}
            compact
            tableFixed
          />
        )}
      </div>
    </Layout>
  );
};

export default Leaderboard;
